import { upcomingRenewalMembersDataset } from '@/lib/member-views/datasets/upcomingRenewalMembers.dataset';
import type { UpcomingRenewalMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<UpcomingRenewalMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Upcoming Renewals: the practice's Active members renewing soon.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function UpcomingRenewalMembersView() {
  return <MemberViewShell dataset={upcomingRenewalMembersDataset} cellOverrides={cellOverrides} />;
}
